export default {
  message: {
    Tour: {
      continue: "চালিয়ে যান",
      back: "ফিরে যান",
      finish: "শেষ"
    },
    Login: {
      title: "অভিভাবক সাইন ইন",
      sign_in: "সাইন ইন",
      login_fail:
        "প্রমাণীকরণ ব্যর্থ। অনুগ্রহ করে আবার চেষ্টা করুন বা সাইন ইনের জন্য সাহায্যের জন্য আপনার স্কুলের সাথে যোগাযোগ করুন।",
      forgot_password: "পাসওয়ার্ড ভুলে গেছেন",
      create_account: "অ্যাকাউন্ট তৈরি করুন",
      password: "পাসওয়ার্ড",
      confirm_password: "পাসওয়ার্ড নিশ্চিত করুন",
      password_reminder: "পাসওয়ার্ড অনুস্মারক",
      enter_email: "আপনার ইমেইল ঠিকানা লিখুন",
      validation_error: "বৈধতা ত্রুটি বার্তা",
      password_reminder_error_no_user_register:
        "আপনার প্রবেশ করানো ব্যবহারকারীর নাম খুঁজে পাওয়া যায়নি। অনুগ্রহ করে আবার চেষ্টা করুন বা একটি নতুন অ্যাকাউন্ট তৈরি করুন।",
      password_reminder_error_no_user: "আপনার প্রবেশ করানো ব্যবহারকারীর নাম খুঁজে পাওয়া যায়নি।",
      password_reminder_sent: "আরও নির্দেশাবলী সহ একটি ইমেইল {email}-এ পাঠানো হয়েছে।",
      password_reminder_sent_message:
        "ইমেইলটি আসতে কয়েক মিনিট সময় লাগতে পারে। যদি আপনি এটি আপনার ইনবক্সে না দেখেন, তাহলে আপনার স্প্যাম ফোল্ডার চেক করুন।",
      password_trouble_email:
        "যদি আপনার এখনও সমস্যা হয়, তাহলে অনুগ্রহ করে {email}-এর সাথে যোগাযোগ করুন।",
      password_trouble_school:
        "যদি আপনার এখনও সমস্যা হয়, তাহলে অনুগ্রহ করে সাহায্যের জন্য আপনার স্কুলের সাথে যোগাযোগ করুন।",
      return_to_sign_in: "সাইন ইনে ফিরে যান",
      create_my_account: "আমার অ্যাকাউন্ট তৈরি করুন",
      or_sign_in_with: "অথবা এর সাথে সাইন ইন করুন",
      password_reset: "অনুগ্রহ করে আপনার অ্যাকাউন্টের জন্য একটি নতুন পাসওয়ার্ড বেছে নিন।",
      password_reset_warning:
        "যদি আপনি আপনার পাসওয়ার্ড পরিবর্তনের জন্য অনুরোধ না করে থাকেন, তাহলে অনুগ্রহ করে অবিলম্বে আপনার স্কুল প্রশাসকের সাথে যোগাযোগ করুন।",
      password_update: "নতুন পাসওয়ার্ড বেছে নিন",
      password_update_confirm: "নতুন পাসওয়ার্ড নিশ্চিত করুন",
      password_update_success: "আপনার নতুন পাসওয়ার্ড সংরক্ষিত হয়েছে।"
    },
    AccountSettings: {
      title: "অ্যাকাউন্ট সেটিংস",
      first_name: "প্রথম নাম",
      last_name: "শেষ নাম",
      email: "ইমেইল",
      username: "ব্যবহারকারীর নাম",
      password: "পাসওয়ার্ড",
      students: "শিক্ষার্থীরা",
      teachers: "শিক্ষকরা",
      external_id: "বাহ্যিক আইডি",
      phone: "ফোন নম্বর",
      phone_required: "ফোন নম্বর প্রয়োজন",
      edit: "সম্পাদনা",
      remove: "সরান",
      add: "যোগ করুন",
      remove_message: "আপনি কি নিশ্চিত যে আপনি এই শিক্ষার্থীর নাম সরাতে চান?",
      yes: "হ্যাঁ",
      no: "না",
      add_student: "শিক্ষার্থী যোগ করুন",
      close: "বন্ধ",
      save: "পরিবর্তন সংরক্ষণ করুন",
      cancel: "বাতিল",
      student_alert_message: "আপনাকে কমপক্ষে একজন শিক্ষার্থী প্রবেশ করাতে হবে।",
      logout: "লগ আউট"
    },
    TrialStatus: {
      title: "Update Trial Status",
      schoolLabel: "School",
      currentStatus: "Current Status",
      newStatus: "New Status",
      updatedSuccess: "Trial status updated successfully",
      updateError: "Failed to update trial status",
      statuses: {
        requested: "Requested",
        pending: "Pending",
        fullfilled: "Fulfilled",
        expired: "Expired",
        cancelled: "Cancelled",
        rejected: "Rejected",
        converted: "Converted"
      }
    },
    LeadStatus: {
      title: "Update Lead Status",
      schoolLabel: "School",
      currentStatus: "Current Status",
      newStatus: "New Status",
      reject: "Reject",
      updatedSuccess: "Lead status updated successfully",
      updateError: "Failed to update lead status",
      convertedNote: "This marks the lead as a customer. If a school exists, it may be set to active.",
      suppressedNote: "This suppresses the lead. You can restore it later from Suppressed.",
      statuses: {
        requested: "Requested",
        pending: "Pending",
        fullfilled: "Fulfilled",
        expired: "Expired",
        cancelled: "Cancelled",
        rejected: "Rejected",
        converted: "Converted"
      }
    },
    WelcomeEmail: {
      title: "Send welcome email?",
      schoolLabel: "School",
      districtLabel: "District",
      contactLabel: "Contact",
      emailLabel: "Email",
      subdomainLabel: "Subdomain",
      usernameLabel: "Username",
      body: "PTC Wizard will email this account's admin-site credentials and documentation links.",
      confirm: "Send email",
      cancel: "Cancel",
      success: "Welcome email sent",
      error: "Failed to send welcome email",
      tooltip: "Send welcome email"
    },
    Navbar: {
      my_meetings: "আমার মিটিংগুলি",
      language: "বাংলা",
      help: "সাহায্য",
      account_settings: "অ্যাকাউন্ট সেটিংস",
      user_management: "User Management",
      logout: "লগ আউট"
    },
    SubNavbar: {
      meeting: "মিটিং",
      event: "ইভেন্ট",
      print: "প্রিন্ট",
      email: "ইমেইল",
      export: "রপ্তানি"
    },
    ConferenceCard: {
      add_edit_meetings: "মিটিং যোগ/সম্পাদনা করুন",
      opening: "খোলা",
      closed: "বন্ধ"
    },
    Agenda: {
      full_agenda: "সম্পূর্ণ এজেন্ডা",
      empty_state_title: "আমরা আপনার জন্য কোন কনফারেন্স খুঁজে পাইনি।",
      empty_state_message:
        "যদি আপনার কোন প্রশ্ন থাকে, তাহলে অনুগ্রহ করে আপনার স্কুলের প্রতিনিধির সাথে যোগাযোগ করুন।",
      confirmation_modal_title: "এজেন্ডা নিশ্চিত",
      confirmation_modal_message:
        "আপনার এজেন্ডা সফলভাবে নিশ্চিত হয়েছে এবং আপনার কাছে একটি ইমেইল পাঠানো হয়েছে।",
      complete_button: "সম্পন্ন!"
    },
    AgendaCard: {
      room: "কক্ষ অনুপলব্ধ",
      room_with_value: "কক্ষ: {room}",
      virtual_meeting: "ভার্চুয়াল মিটিং",
      all_conferences: "সকল কনফারেন্স",
      conference: "কনফারেন্স",
      student: "শিক্ষার্থী",
      meeting_with: "এর সাথে মিটিং",
      date_time: "তারিখ/সময়",
      meeting_type: "মিটিং প্রকার",
      location: "অবস্থান",
      comment: "মন্তব্য",
      action: "কর্ম",
      delete: "মুছুন",
      add_comment: "মন্তব্য যোগ করুন",
      join: "মিটিংয়ে যোগ দিন",
      choose_meeting_type: "মিটিং প্রকার বেছে নিন",
      in_person: "ব্যক্তিগতভাবে",
      phone: "ফোন",
      callback: "কলব্যাক",
      virtual: "ভার্চুয়াল",
      hybrid: "হাইব্রিড",
      unavailable: "উপলব্ধ নয়",
      tooltip_translator:
        "অনুবাদ পরিষেবা নিশ্চিত নয়, তবে স্কুল এটি উপলব্ধ করতে সর্বাত্মক প্রচেষ্টা করবে।",
      translator_requested: "{language} দোভাষী অনুরোধ করা হয়েছে",
      clear_translator: "দোভাষীর অনুরোধ মুছুন",
      need_translator: "দোভাষীর প্রয়োজন?",
      choose_language: "একটি ভাষা নির্বাচন করুন"
    },
    ScheduleMatrix: {
      no_teachers_title: "কোন শিক্ষক বা টিম নির্বাচিত নেই।",
      no_teachers_message: "তাদের মিটিং সময় দেখতে অনুগ্রহ করে একজন শিক্ষক বেছে নিন।",
      choose_teachers_button: "উপলব্ধ শিক্ষক বা টিম দেখুন",
      choose_student: "কোন শিক্ষার্থীর জন্য?",
      cancel: "বাতিল"
    },
    Matrix: {
      teachers: "শিক্ষকরা",
      agenda: "পর্যালোচনা এবং চালিয়ে যান"
    },
    DrawerTeachers: {
      teachers: "শিক্ষকরা",
      name: "নাম",
      description: "বিবরণ",
      student: "শিক্ষার্থী",
      teacher_team: "শিক্ষক/টিম",
      show_more: "আরও শিক্ষক দেখান",
      show_all: "স্কুলের সকল শিক্ষক দেখান",
      selected: "({count}) নির্বাচিত",
      closeDrawer: "সময়সূচী করতে চালিয়ে যান",
      search: "একজন শিক্ষক বা টিম অনুসন্ধান করুন",
      not_available: "এই শিক্ষকটির {date} তারিখে কোনো উপলব্ধ মিটিং সময় নেই।"
    },
    DrawerAgenda: {
      no_meetings_title: "আপনার কোন মিটিং নির্ধারিত নেই।",
      no_meetings_message:
        "একবার আপনি একজন শিক্ষক এবং একটি সময়কাল বেছে নিলে, এটি এখানে দেখা যাবে।",
      new_meeting_label: "নতুন",
      cancel_button: "বাতিল",
      student_label: "শিক্ষার্থী",
      meeting_type_location: "মিটিং প্রকার/অবস্থান",
      comment_label: "মন্তব্য",
      save_comment_button: "মন্তব্য সংরক্ষণ করুন",
      confirm_label: "অনুগ্রহ করে নিশ্চিত করুন:",
      confirm_cancel_button: "হ্যাঁ, আমার মিটিং বাতিল করুন ",
      do_not_cancel_button: "বাতিল করবেন না",
      confirm_agenda_button: "এই এজেন্ডা নিশ্চিত করুন",
      confirm_agenda_message_line1: "আপনি সর্বদা ফিরে আসতে এবং পরিবর্তন করতে পারেন।",
      confirm_agenda_message_line2: "আপনার বর্তমান এজেন্ডা আপনার কাছে ইমেইল করা হবে।"
    },
    EmailConsent: {
      message:
        "আপনার গোপনীয়তা এবং নিরাপত্তা রক্ষার প্রচেষ্টায়, আমাদের সিস্টেম থেকে আপনার ইমেইল ঠিকানায় যোগাযোগ পাওয়ার জন্য আপনার সম্মতির প্রয়োজন।",
      consent: "সম্মতি"
    },
    UserManagement: {
      pageTitle: "User Management",
      pageSubtitle:
        "Add and manage school and district staff accounts. Staff sign in with school or district login using this site's account.",
      addUser: "Add user",
      editUser: "Edit user",
      loading: "Loading users…",
      emptyTitle: "No staff users yet",
      emptyMessage: "Use Add user to create a school or district staff account.",
      tableUsername: "Username",
      tableEmail: "Email",
      tableRole: "Role",
      tableActions: "Actions",
      typeSchool: "School",
      typeDistrict: "District",
      roleTeam: "Team",
      roleSchool: "School Admin",
      roleReporter: "School Reporter",
      roleDistrict: "District Admin",
      roleNoIntegration: "School Admin without Integration",
      roleNotSet: "Role not set",
      roleUnknown: "Role ({id})",
      formUsername: "Username",
      formEmail: "Email",
      formPassword: "Password",
      formNewPassword: "New password (optional)",
      formRole: "Role",
      loginHint:
        "Staff sign in with the school portal. District staff may use the district portal subdomain when applicable.",
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      confirmDeleteTitle: "Remove this user?",
      confirmDeleteBody:
        "This will remove the staff account from your school. This action cannot be undone.",
      validationRequired: "Please fill in all required fields.",
      createdSuccess: "User created.",
      updatedSuccess: "User updated.",
      deletedSuccess: "User removed.",
      genericError: "Something went wrong. Please try again.",
      changeRoleTitle: "Change role",
      roleUpdatedSuccess: "Role updated.",
      deleteUserAria: "Remove user",
      formSchool: "School",
      validationSchoolRequired: "Please select a school.",
      schoolListEmpty: "No schools are available in this district."
    },
    StudentsDirectory: {
      saveLinkHousehold: "Save link household",
      saveLinkHouseholdNothing: "No changes to save.",
      saveLinkHouseholdSuccess: "Link household updated for {count} students.",
      saveLinkHouseholdError: "Could not update link household.",
      saveLinkHouseholdPartial: "Updated {saved} students; {failed} could not be saved."
    }
  }
};
